// src/services/authService.js
import api from './api';

export const authService = {
  // Register user
  async register(userData) {
    const response = await api.post('/v1/auth/register', userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Login user
  async login(credentials) {
    const response = await api.post('/v1/auth/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout user (server-side request + local cleanup)
  async logout() {
    try {
      await api.post('/v1/auth/logout');
    } catch (err) {
      // ignore server errors during logout
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // Get current user from localStorage
  getCurrentUser() {
    const user = localStorage.getItem('user');

    // Handle cases where the stored value is the literal string "undefined" or "null"
    if (!user || user === 'undefined' || user === 'null') {
      localStorage.removeItem('user');
      return null;
    }
    try {
      return JSON.parse(user);
    } catch (err) {
      // If parsing fails, remove the corrupt value and return null
      localStorage.removeItem('user');
      return null;
    }
  },

  // Get current user from server
  async me() {
    const response = await api.get('/v1/users/me');
    if (response.data.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Update profile (PATCH /v1/users/update-me)
  async updateProfile(userData) {
    const response = await api.patch('/v1/users/update-me', userData);
    if (response.data.user || response.data.data?.user) {
      const user = response.data.user || response.data.data.user;
      localStorage.setItem('user', JSON.stringify(user));
    }
    return response.data;
  },

  // Update password (PATCH /v1/auth/update-password)
  async updatePassword(currentPassword, newPassword) {
    const response = await api.patch('/v1/auth/update-password', { currentPassword, newPassword });
    return response.data;
  },

  // Verify email with numeric code
  async verifyEmail({ email, code }) {
    const response = await api.post('/v1/auth/verify-email', { email, code });
    // If server logs the user in (e.g., after reactivation), store token & user
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Resend verification code
  async resendVerification({ email }) {
    const response = await api.post('/v1/auth/resend-verification', { email });
    return response.data;
  },

  // Request reactivation (sends a code)
  async requestReactivation({ email }) {
    const response = await api.post('/v1/auth/request-reactivation', { email });
    return response.data;
  },

  // Reactivate account using code
  async reactivate({ email, code }) {
    const response = await api.post('/v1/auth/reactivate', { email, code });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Forgot password
  async forgotPassword({ email }) {
    const response = await api.post('/v1/auth/forgot-password', { email });
    return response.data;
  },

  // Reset password
  async resetPassword({ token, password, passwordConfirm }) {
    const response = await api.patch(`/v1/auth/reset-password/${token}`, { password, passwordConfirm });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },




};
